import type { SignUpData, TipoDocumento } from "types/auth";
import "styles/cadastro.css";
import { useTranslation } from "react-i18next";

type Props = {
  data: SignUpData;
  onNext: (p: Partial<SignUpData>) => void;
};

export default function StepTipoDocumento({ data, onNext }: Props) {
  const { t } = useTranslation();

  const escolher = (tipoDocumento: TipoDocumento) => {
    onNext({ tipoDocumento });
  };

  const opcoes: { valor: TipoDocumento; titulo: string; desc: string }[] = [
    {
      valor: "cnpj",
      titulo: t("fields.tipo_documento_brasileira"),
      desc: t("fields.tipo_documento_brasileira_desc"),
    },
    {
      valor: "cpf",
      titulo: t("fields.tipo_documento_pf"),
      desc: t("fields.tipo_documento_pf_desc"),
    },
    {
      valor: "estrangeiro",
      titulo: t("fields.tipo_documento_estrangeira"),
      desc: t("fields.tipo_documento_estrangeira_desc"),
    },
  ];

  return (
    <div>
      <h3 className="font-semibold text-lg mb-1">{t("fields.tipo_documento_title")}</h3>
      <p className="text-sm text-gray-500 mb-4">{t("fields.tipo_documento_subtitle")}</p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {opcoes.map((op) => (
          <button
            key={op.valor}
            type="button"
            onClick={() => escolher(op.valor)}
            className={`text-left border rounded-lg p-4 transition-colors hover:border-brand-primary ${
              data.tipoDocumento === op.valor
                ? "border-brand-primary bg-brand-primary/5"
                : "border-gray-300"
            }`}
          >
            <p className="font-semibold text-sm">{op.titulo}</p>
            <p className="text-xs text-gray-500 mt-1">{op.desc}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
